import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const EmptyDetailViewParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(EmptyDetailViewParts)

export const EmptyDetailViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      boxSize: 'full',
    },
    text: {
      userSelect: 'none',
      color: 'fg.muted',
      textAlign: 'center',
      ...textStyles[textStyleKeys.Display2],
    },
  },
})

export const useEmptyDetailViewStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(EmptyDetailViewStyle, props) as MultiStyleType<
    typeof EmptyDetailViewParts
  >
}
